import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import {useInertiaState} from "./Layout";
import Checkbox from "./Checkbox";

import { Trans } from "../utils/i18n";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";

const AddressSelect = React.memo(function ({ company, address, addAddress, addCompany, custom_address, requesttype }) {
        const { companies } = useInertiaState();
        const { addresses, serialNumber } = useFormState();
        const orderEntryDispatch = useFormStateDispatch();

        useEffect(() => {
            if(companies.length === 1) {
                addCompany(companies[0].id);
            }
        }, [addresses, address, custom_address]);

        useEffect(() => {
            if(company) {
                fetch(route('order.addresses', {company_id: company}))
                    .then(response => response.json())
                    .then(response => {
                        if(!response.success) {
                            throw 'error';
                        }
                        orderEntryDispatch({ type: 'setAddresses', value: response.addresses });
                        addAddress(null);
                    })
            }
        }, [company]);

        useEffect(() => {
            if(addresses && !custom_address && address) {
                const selectedAdress = addresses.find((item) => item.id == address);
                addAddress(selectedAdress);
            }
        }, [addresses, address, custom_address]);

        return (
            <>
                {
                    companies.length > 1 &&
                    <Field
                        name={'company_id'}
                        type={'select'}
                        component={Select}
                        validate={value => (value ? undefined : 'Required')}
                        disabled={['incident'].includes(requesttype)}
                        field={{
                            label: <Trans i18nKey="addressSelect.selectACompany">Select a company</Trans>,
                            titel: <Trans i18nKey="addressSelect.companyTitle">123</Trans>,
                            options: companies.map(company => ({
                                value: company.id,
                                label: company.name,
                            })),
                        }}
                    />
                }
                {
                    company &&
                    !addresses  &&
                    <div><Trans i18nKey="addressSelect.loading">Loading</Trans></div>
                }
                {
                    (companies.length === 1 || companies.length > 1 && company) &&
                    addresses &&
                    <>
                        <div style={{marginTop: 15}}></div>
                        <Field
                            name={'address'}
                            type={'select'}
                            component={Select}
                            field={{
                                label: <Trans i18nKey="addressSelect.selectDeliveryAddress">Select delivery address</Trans>,
                                titel: <Trans i18nKey="addressSelect.deliveryAddressTitle">123</Trans>,
                                options: addresses.map(address => ({
                                    value: address.id,
                                    label: address.name,
                                })),
                            }}
                            disabled={custom_address}
                        />
                        <Field
                            name={'custom_address'}
                            type={'checkbox'}
                            component={Checkbox}
                            // validate={value => (value ? undefined : 'Erforderlich')}
                            field={{
                                "name": "custom_address",
                                "label": <Trans i18nKey="addressSelect.newAddress">New address</Trans>,
                                "size": "full",
                            }}
                        />
                    </>
                }
            </>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default AddressSelect;
